import {State} from './state';
import {Country} from './country';
import {BaseModel} from '../baseModel';
import {PartnerType} from './partner-type';
import {Company} from './company';
import {Attachment} from './attachment';
import {Assignee} from '../accr/Assignee';

export class Partner extends BaseModel<number> {
  override id?: number;
  name?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  credentials?: string;
  street1?: string;
  street2?: string;
  gender?: string;
  birthDate?: any;
  zipCode?: string;
  zipCodeSuffix?: string;
  phone?: string;
  email?: string;
  country?: Country;
  city?: string;
  state?: State;
  county?: any;
  type?: PartnerType;
  parent?: Partner;
  company?: Company;
  defaultBillingAddress?: boolean;
  logo?: Attachment;
  suffix?: string;
  fax?: string;
  active?: boolean = true;
  phoneCountryCode?: string;
  phoneExtension?: string;
  faxExtension?: string;
  assignee?: Assignee = new Assignee();
}
